"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreStorage = void 0;
const sanitizers_1 = require("@restless/sanitizers");
const ethers_1 = require("ethers");
const __1 = require("../..");
class ScoreStorage {
    constructor(arcxLogger) {
        this.arcxLogger = arcxLogger;
        this.FORMAT_SIMPLE_LIMIT = 50000;
        this.FORMAT_PROOF_LIMIT = 5000;
        this.FORMAT_FULL_LIMIT = 1000;
    }
    getScoreCount(collection, params) {
        return __awaiter(this, void 0, void 0, function* () {
            return collection.countDocuments(this.handleQuery(params));
        });
    }
    getScores(collection, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const foundScores = [];
            // limit of 0 is the same as having no limit: https://docs.mongodb.com/manual/reference/method/cursor.limit/
            const limit = this.handleLimit(params);
            const query = this.handleQuery(params);
            const sort = this.handleSort(params);
            const projection = this.handleProjection(params);
            const needsFormatedProtocol = params.format === 'proof' || params.enforceBytes32Protocol;
            const protocol_bytes32 = needsFormatedProtocol ? ethers_1.utils.formatBytes32String(params.protocol) : '';
            try {
                yield new Promise((resolve, reject) => {
                    const stream = collection
                        .find(query)
                        .project(projection)
                        .skip(params.offset || 0)
                        .limit(limit)
                        .sort(sort)
                        .stream();
                    stream.on('error', function (err) {
                        reject(err);
                    });
                    stream.on('data', function (score) {
                        if (needsFormatedProtocol) {
                            score = Object.assign(Object.assign({}, score), { protocol: protocol_bytes32, merkleProof: score.merkleProof || [] });
                        }
                        foundScores.push(score);
                    });
                    stream.on('end', function () {
                        resolve();
                    });
                });
            }
            catch (error) {
                this.arcxLogger.error(`ScoreStorage::readFromCollection => ${error}`);
            }
            return (0, sanitizers_1.cast)(foundScores, (0, sanitizers_1.asArray)(__1.asScore));
        });
    }
    handleProjection(params) {
        const simpleFilter = {
            _id: 0,
            account: 1,
            score: 1,
            protocol: 1,
        };
        const format = params.format || 'simple';
        switch (format) {
            case 'simple':
                return simpleFilter;
            case 'proof':
                return Object.assign(Object.assign({}, simpleFilter), { merkleProof: 1 });
            case 'full':
                return Object.assign(Object.assign({}, simpleFilter), { merkleProof: 1, metadata: 1 });
        }
    }
    handleQuery(params) {
        if (!params)
            return {};
        const queries = [];
        if (params.accounts && params.accounts.length) {
            queries.push({
                account: params.accounts.length === 1 ? params.accounts[0] : { $in: params.accounts },
            });
        }
        if (params.epoch) {
            queries.push({ epoch: params.epoch });
        }
        if (params.protocol) {
            queries.push({ protocol: params.protocol });
        }
        if (params.greaterThan) {
            queries.push({ $expr: { $gt: [{ $toDouble: '$score' }, { $toDouble: params.greaterThan }] } });
        }
        if (params.lessThan) {
            queries.push({ $expr: { $lt: [{ $toDouble: '$score' }, { $toDouble: params.lessThan }] } });
        }
        return {
            $and: queries,
        };
    }
    handleSort(params) {
        let sortBy = params.sortBy || 'account';
        if (sortBy === 'rank')
            sortBy = 'metadata.rank'; // rank is embedded in metadata
        return {
            [sortBy]: params.sortOrder === 'desc' ? -1 : 1,
        };
    }
    handleLimit(params) {
        if (params.ignoreLimit)
            return 0;
        const format = params.format || 'simple';
        // Assumption: FORMAT_SIMPLE_LIMIT is always the highest limit
        const limit = params.limit || this.FORMAT_SIMPLE_LIMIT;
        switch (format) {
            case 'simple':
                return limit > this.FORMAT_SIMPLE_LIMIT ? this.FORMAT_SIMPLE_LIMIT : limit;
            case 'proof':
                return limit > this.FORMAT_PROOF_LIMIT ? this.FORMAT_PROOF_LIMIT : limit;
            case 'full':
                return limit > this.FORMAT_FULL_LIMIT ? this.FORMAT_FULL_LIMIT : limit;
        }
    }
}
exports.ScoreStorage = ScoreStorage;
//# sourceMappingURL=ScoreStorage.js.map